import React, { useState, useEffect, useRef, useLayoutEffect } from 'react'
import "../css/contact.css"
import { motion, useScroll, useTransform, AnimatePresence, useSpring } from "framer-motion" 
import flag from "../assets/christian2000.jpg"
import Footer from './Footer'
import dots from '../assets/dots.svg'
import Copyright2 from './Copyright2'
import ByManta from './ByManta'
import { useInView } from 'react-intersection-observer'
import contactsvg from '../assets/contact.svg'

const Contact = () => {

const [ contact1, setContact1 ] = useState(true)
const [ contact2, setContact2 ] = useState(false)
const [ contact3, setContact3 ] = useState(false)
const [ ref2, inView2 ] = useInView()

const contactRef1 = useRef()
const contactRef2 = useRef()
const contactRef3 = useRef()
const targetRef = useRef()
const spacerRef = useRef()
const innerRef = useRef()
const contentRef = useRef()



// const { scrollYProgress } = useScroll({
//     target: targetRef,
//     offset: ["start start", "end start"]
// })

  const { scrollY } = useScroll();

  // Smooth the scroll
  const smoothY = useSpring(scrollY, {
    damping: 40,
    stiffness: 200,
    mass: 0.2,
  });

    const inverted = useTransform(smoothY, v => -v)

    const y = useTransform(smoothY, [0, 1600], [0, 300])
    const y2 = useTransform(smoothY, [0, 1600], [0, 150])

useLayoutEffect(() => {
    const el = innerRef.current;
    if (!el) return;

    const update = () => {
      const h = el.getBoundingClientRect().height;
      spacerRef.current.style.height = `${h}px`;
    };

    update(); // initial

    const observer = new ResizeObserver(update);
    observer.observe(el);

    return () => observer.disconnect();
  }, []);



const contactVar1 = {
  open: { height: 200, transition: { duration: 0.5 } },
  closed: { height: 0, transition: { duration: 0.5 } }
}

const contactVar2 = {
  open: { height: 170, transition: { duration: 0.5 } },
  closed: { height: 0, transition: { duration: 0.5 } }
}

const contactVar3 = {
  open: { height: 135, transition: { duration: 0.5 } },
  closed: { height: 0, transition: { duration: 0.5 } }
}

let title = {
  closed: { opacity: 1 },
  open: { opacity: 1, transition: { delayChildren: 1.2, staggerChildren: 0.1 }}
}

let letters = {
  closed: { y: "24vw" },
  open: { y: 0, transition: { duration: 1, ease: [0.5, 0.7, 0.05, 1] } }
}

useEffect(() => {
  let contact1Handler = (e) => { 
      if(!contactRef1.current.contains(e.target)){
          setContact1(false)
      }
  } 
  document.addEventListener("mousedown", contact1Handler)
}, [])

useEffect(() => {
  let contact2Handler = (e) => { 
      if(!contactRef2.current.contains(e.target)){
          setContact2(false)
      }
  } 
  document.addEventListener("mousedown", contact2Handler)
}, [])

useEffect(() => {
  let contact3Handler = (e) => { 
      if(!contactRef3.current.contains(e.target)){
          setContact3(false)
      }
  } 
  document.addEventListener("mousedown", contact3Handler)
}, [])


  return (
    <AnimatePresence mode={"wait"}>
      <div style={{ position: 'fixed' }}>
        <Copyright2 />
        <ByManta />
        <Footer inView2={ inView2 } /> 
        <motion.div ref={ contentRef } style={{ position: 'relative', y: inverted, width: '100vw' }}>
            <div ref={ innerRef }>
              <div className="contact-grid">
                
            
                  <div className="contact-header">

                    <motion.img ref={targetRef} initial={{ opacity: 0 }} animate={{ opacity: 1, transition: { delay: 2.5, duration: 1 }}} className="contact-header-img" src={flag} alt="" style={{ y: y2 }} />

                    

                    <motion.div style={{ height: 'max-content', y }} 
                    // variants={ title } initial="closed" 
                    // animate="open" 
                    className="contact-text">
                        <motion.div style={{ display: 'flex', width: '100%', height: 'max-contact', overflow: 'hidden' }}>
                            <motion.svg initial={{ y: '180%' }} animate={{ y: '0%', transition: { ease: [0.9, 0.5, 0, 0.8], duration: 1, delay: 1 } }} style={{ fill: '#fff000', width: '100%', height: 'auto' }} id="Layer_1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 710.01 114.99">
                              <path class="st0" d="M53.38,114.99c-10.13,0-19.23-2.26-27.29-6.77-8.06-4.52-14.42-11.07-19.09-19.65C2.33,79.98,0,69.65,0,57.57s2.33-22.56,7-31.14c4.67-8.58,11.03-15.13,19.09-19.65C34.15,2.26,43.24,0,53.38,0c6.79,0,13.05.99,18.79,2.96,5.74,1.97,10.8,4.79,15.2,8.46,4.39,3.67,7.98,8.08,10.78,13.25,2.79,5.17,4.59,10.97,5.39,17.41h-27.1c-.5-2.94-1.4-5.56-2.7-7.86-1.3-2.29-2.92-4.24-4.87-5.84-1.95-1.6-4.18-2.82-6.7-3.67-2.52-.85-5.28-1.27-8.27-1.27-5.69,0-10.53,1.36-14.52,4.08-3.99,2.72-7.04,6.62-9.13,11.72-2.1,5.09-3.14,11.2-3.14,18.34s1.05,13.24,3.14,18.3c2.1,5.07,5.14,8.95,9.13,11.64,3.99,2.7,8.81,4.04,14.45,4.04,3.04,0,5.81-.41,8.31-1.24,2.5-.82,4.72-2.05,6.66-3.67,1.95-1.62,3.57-3.57,4.87-5.84,1.3-2.27,2.25-4.88,2.84-7.82h27.02c-.75,6.09-2.47,11.69-5.17,16.81-2.7,5.12-6.23,9.56-10.59,13.33-4.37,3.77-9.45,6.69-15.23,8.76-5.79,2.07-12.18,3.11-19.16,3.11Z"/>
                              <path class="st0" d="M160.84,114.99c-10.08,0-19.15-2.27-27.21-6.81-8.06-4.54-14.42-11.09-19.09-19.65-4.67-8.56-7-18.88-7-30.96s2.33-22.56,7-31.14c4.67-8.58,11.03-15.13,19.09-19.65,8.06-4.52,17.13-6.77,27.21-6.77s19.06,2.26,27.1,6.77c8.03,4.52,14.41,11.07,19.13,19.65,4.72,8.58,7.07,18.97,7.07,31.14s-2.36,22.47-7.07,31.03c-4.72,8.56-11.09,15.1-19.13,19.61-8.04,4.52-17.07,6.77-27.1,6.77ZM160.84,91.56c5.34,0,9.97-1.32,13.89-3.97,3.92-2.64,6.95-6.51,9.1-11.6,2.15-5.09,3.22-11.23,3.22-18.42s-1.07-13.41-3.22-18.53c-2.15-5.12-5.18-9-9.1-11.64-3.92-2.64-8.55-3.97-13.89-3.97s-9.97,1.32-13.89,3.97c-3.92,2.65-6.95,6.53-9.1,11.64-2.15,5.12-3.22,11.29-3.22,18.53s1.07,13.33,3.22,18.42c2.15,5.09,5.18,8.96,9.1,11.6,3.92,2.65,8.55,3.97,13.89,3.97Z"/>
                              <path class="st0" d="M319.67,1.73v111.54h-28.15l-28.97-46.41c-1.65-2.7-3.53-5.88-5.65-9.55-2.12-3.67-4.39-7.77-6.81-12.31-.77-1.45-1.56-2.94-2.37-4.46.06,1.25.11,2.49.16,3.71.2,4.94.34,9.37.41,13.29.08,3.91.11,7.02.11,9.32v46.41h-26.95V1.73h28.08l31.59,50.6c1.34,2.2,2.9,4.89,4.68,8.09,1.77,3.19,3.63,6.65,5.57,10.37.66,1.26,1.31,2.52,1.94,3.79-.19-4.79-.34-9.41-.44-13.86-.1-4.49-.15-8.11-.15-10.86V1.73h26.95Z"/>
                              <path class="st0" d="M326.22,24.33V1.72h92.83v22.61h-33.01v88.94h-26.8V24.33h-33.01Z"/>
                              <path class="st0" d="M477.94,1.73h-35.49l-38.1,111.54h29.27l6.94-21.93h39.03l6.81,21.93h30.02L477.94,1.73ZM447.18,70.45l1.94-6.14c2.49-8.18,4.91-16.53,7.26-25.04,1.23-4.49,2.5-9.16,3.79-14,1.29,4.84,2.55,9.51,3.81,14,2.37,8.51,4.77,16.86,7.22,25.04l1.91,6.14h-25.93Z"/>
                              <path class="st0" d="M563.84,114.99c-10.13,0-19.23-2.26-27.29-6.77-8.06-4.52-14.42-11.07-19.09-19.65-4.67-8.58-7-18.91-7-30.99s2.33-22.56,7-31.14c4.67-8.58,11.03-15.13,19.09-19.65,8.06-4.52,17.16-6.77,27.29-6.77,6.79,0,13.05.99,18.79,2.96,5.74,1.97,10.8,4.79,15.2,8.46,4.39,3.67,7.98,8.08,10.78,13.25,2.79,5.17,4.59,10.97,5.39,17.41h-27.1c-.5-2.94-1.4-5.56-2.7-7.86-1.3-2.29-2.92-4.24-4.87-5.84-1.95-1.6-4.18-2.82-6.7-3.67-2.52-.85-5.28-1.27-8.27-1.27-5.69,0-10.53,1.36-14.52,4.08-3.99,2.72-7.04,6.62-9.13,11.72-2.1,5.09-3.14,11.2-3.14,18.34s1.05,13.24,3.14,18.3c2.1,5.07,5.14,8.95,9.13,11.64,3.99,2.7,8.81,4.04,14.45,4.04,3.04,0,5.81-.41,8.31-1.24,2.5-.82,4.72-2.05,6.66-3.67,1.95-1.62,3.57-3.57,4.87-5.84,1.3-2.27,2.25-4.88,2.84-7.82h27.02c-.75,6.09-2.47,11.69-5.17,16.81-2.7,5.12-6.23,9.56-10.59,13.33-4.37,3.77-9.45,6.69-15.23,8.76-5.79,2.07-12.18,3.11-19.16,3.11Z"/>
                              <path class="st0" d="M617.19,24.33V1.72h92.83v22.61h-33.01v88.94h-26.8V24.33h-33.01Z"/>
                            </motion.svg>
                          {/* <motion.img src={ contactsvg } initial={{ y: '180%' }} animate={{ y: '0%', transition: { ease: [0.9, 0.5, 0, 0.8], duration: 1, delay: 1 }  }} style={{ width: '100%', height: 'auto' }} /> */}
                        </motion.div>
                      <div style={{ height: '14px', position: 'absolute', bottom: -18, left: 0, overflow: 'hidden' }}>
                        <motion.h5 initial={{ y: '100%' }} animate={{ y: '0%', transition: { ease: [0.9, 0.5, 0, 0.8], duration: 1, delay: 1.6 } }} style={{ marginTop: '-2px' }}>"SEND ME</motion.h5>
                      </div>
                      <div style={{ height: '14px', position: 'absolute', bottom: -18, right: 0, overflow: 'hidden' }}>
                        <motion.h5 initial={{ y: '100%' }} animate={{ y: '0%', transition: { ease: [0.9, 0.5, 0, 0.8], duration: 1, delay: 1.8 } }} style={{ marginTop: '-2px' }}>AN EMOJI"</motion.h5>
                      </div>
                    </motion.div>

                  </div>
          
                  <div className="contact-section"
                  style={{ 
                        filter: "blur(0.5px)",
                        WebkitTransform: "translateZ(0)",
                        transform: "translateZ(0)",
                        WebkitBackfaceVisibility: "hidden",
                        backfaceVisibility: "hidden",
                        willChange: "filter" 
                        }}>
                      <div></div>
                      <div className="contact-content">
                        <motion.div style={{ borderBottom: '1px solid #fff00044' }} initial={{ opacity: 0 }} animate={{ opacity: 1, transition: { delay: 2.9, duration: 1.4 }}} className="contact-enquiries" ref={contactRef1} onClick={() => setContact1(true)}>
                          <div className='contact-buttons'>
                            <div>MANAGEMENT</div>
                            <div className='dots-container'><img src={ dots } style={{ width: '20px' }} />
                            </div>
                          </div> 
                          <motion.div variants={ contactVar1 } animate={ contact1 ? "open" : "closed" } className="contact-text1" style={{ textTransform: 'uppercase' }}>
                            <h5>Kelly Money<br /><div className="contact-email"><a whileHover={{ color: "#fff" }} href='mailto:kelly@littleempiremusic.com' target="_blank">kelly@littleempiremusic.com</a></div><br /><br />
                            Paula Quijano<br /><div className="contact-email"><a whileHover={{ color: "#fff" }} href='mailto:PQ@littleempiremusic.com' target="_blank">PQ@littleempiremusic.com</a></div>
                            </h5>
                          </motion.div>
                        </motion.div>
                        <motion.div style={{ borderBottom: '1px solid #fff00044' }} initial={{ opacity: 0 }} animate={{ opacity: 1, transition: { delay: 3.1, duration: 1.4 }}} ref={contactRef2} onClick={() => setContact2(true)} className="contact-booking">
                          <div className='contact-buttons'>
                            <div>BOOKINGS</div>
                            <div className='dots-container'><img src={ dots } style={{ width: '20px' }} />
                            </div>
                          </div>
                          <motion.div variants={ contactVar2 } animate={ contact2 ? "open" : "closed" } className="contact-text2" style={{ textTransform: 'uppercase' }}>
                            <h5>Worldwide<br />
                            William Morris Endeavor<br /><br />
                            <div className="contact-email"><a whileHover={{ color: "#fff" }} href='mailto:Galantis@wmeagency.com' target="_blank">Galantis@wmeagency.com</a></div></h5>
                            </motion.div>
                        </motion.div>
                        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1, transition: { delay: 3.3, duration: 1.4 }}} onClick={() => setContact3(true)} className="contact-booking" ref={contactRef3}>
                        <div className='contact-buttons'>
                            <div>PRESS</div>
                            <div className='dots-container'><img src={ dots } style={{ width: '20px' }} />
                            </div>
                            <motion.div variants={ contactVar3 } animate={ contact3 ? "open" : "closed" } className="contact-text3" style={{ textTransform: 'uppercase' }}>
                            <h5>Press Contact<br />
                            Little Empire Music<br /><br />
                            <div className="contact-email"><a whileHover={{ color: "#fff" }} href='mailto:g@littleempiremusic.com' target="_blank">g@littleempiremusic.com</a></div></h5>
                          </motion.div>
                          </div>
                        </motion.div>
                      </div>
                      <div></div>
                    </div>

              </div>
              <div style={{ height: '1px', width: '100vw' }}>
               <div ref={ ref2 } style={{ marginTop: '1px', width: '100vw' }}></div>
              </div>
            </div>
          </motion.div>
      </div>
      <div className='yo4' style={{ position: 'relative', pointerEvents: 'none' }} ref={ spacerRef }></div>
      <Footer />
    </AnimatePresence>
  )
}

export default Contact